import { LocalizedValueFragment } from "gql/graphql";
import { Hidable, isHidden } from "@/shared/value";

/**
 * Есть ли что показать на месте локализованного значения.
 *
 * Скрытое — есть: плашка «скрыто» и есть то, что здесь нужно показать. Пустое — нет.
 * Проверка нужна там, где вокруг значения стоит оформление — иконка, скобки, чип,
 * разделитель, — которое без значения читается как сломанная вёрстка.
 */
export function hasValue(data: Hidable<LocalizedValueFragment>): boolean {
  if (!data) {
    return false;
  }

  return isHidden(data) ? true : !!data.value;
}

/** То же для сущности, у которой значение лежит в `name`. */
export function hasName(
  data: Hidable<{ name?: LocalizedValueFragment | null }>,
): boolean {
  if (!data) {
    return false;
  }

  return isHidden(data) ? true : hasValue(data.name);
}
